import { useField } from 'formik';
import { useSafeField } from 'hooks/useSafeField';
import React, { FC, ReactElement, useEffect, useState } from 'react';

interface InputProps {
  placeholder?: string;
  type?: string;
  className?: string;
  errorClassName?: string; 
  name?:string;
  inputClassName?:string;
  addonAfter?: ReactElement<{ noErrorHandling?: boolean,isAddon?:boolean, setAddonWasClicked?:any }>; 
  addonBefore?: ReactElement<{ noErrorHandling?: boolean,isAddon?:boolean, setAddonWasClicked?:any }>; 
  addonWidthInRem?: string | number;
  id?: string;
  [key: string]: any; 
}

const Input: FC<InputProps> = ({ 
  placeholder = '',
  type = 'text',
  className = '',
  addonAfter,
  inputClassName,
  errorClassName,
  addonBefore,
  name,
  addonWidthInRem = "8rem",
  id= "",
  ...rest
}) => {
  const [field, meta] = useSafeField(name!);
  const [addonWasClicked, setAddonWasClicked] = useState(false)
  console.log({name, field, rest})

  return (
    <>
      <div
        className={`bg-white ${addonBefore?'flex flex-row-reverse  ':''} ${addonWasClicked && addonAfter?`rounded-s-full  rounded-tr-full `:addonWasClicked && addonBefore?'rounded-tl-[2rem] rounded-tr-[2rem]':'rounded-full '} h-[50px] relative my-3.5 ${
          meta.touched && meta.error && !['radio', 'checkbox'].includes(type)  && Object.keys(meta.error).length?errorClassName?errorClassName: 'ring-2 ring-red-500/50' : ''
        } ${className}`}
        {...rest}
      >
        <input
          {...(!['radio', 'checkbox'].includes(type) ?{
            style:{
               width: addonAfter  ? `calc(100% - ${addonWidthInRem})` : addonBefore?'86%':'100%'
            },
            className:`${addonBefore?'rounded-e-full':addonAfter?'rounded-s-full':'rounded-full'} h-full outline-none bg-transparent block md:pl-6 pl-3 placeholder:text-[#6F6F6F] ${inputClassName}`
          }:{})}

          id={id}
          
          type={type}
          {...field}
          placeholder={placeholder}
          {...rest}
        />

        {/* Addon Component */}
        {addonAfter && React.isValidElement(addonAfter) && (
          <div
            className={`absolute top-0 rounded-full right-0 h-full flex items-center`}
            style={{ width: addonWidthInRem }}
          >
            {React.cloneElement(addonAfter, { noErrorHandling: true, isAddon:true, setAddonWasClicked })}
          </div>
        )}

        {addonBefore && React.isValidElement(addonBefore) && (
          <div
            className={`absolute top-1/2 transform -translate-y-[2.3rem] left-0  ${addonWasClicked?'right-0':''} bottom-[14rem]`}
           
          >
            {React.cloneElement(addonBefore, { noErrorHandling: true, isAddon:true, setAddonWasClicked })}
          </div>
        )}
      </div>

      {/* Validation Error */}
      {meta.touched && meta.error && !['radio', 'checkbox'].includes(type)  && (
        <span className={errorClassName? `${errorClassName} ring-0`: "text-xs text-red-400 block"}>{meta.error}</span>
      )}
    </>
  );
};

export const WOSInput: FC<InputProps> = ({
  placeholder = '',
  type = 'text',
  className = '',
  addonAfter,
  inputClassName,
  errorClassName, 
  addonBefore,
  name,
  addonWidthInRem = "8rem",
  id= "",
  ...rest
}) => {
  const [field, meta] = useSafeField(name!);
  const [addonWasClicked, setAddonWasClicked] = useState(false)
 

  useEffect(()=>{
    console.log({addonWasClicked})
  },[addonWasClicked])

  return (
    <>
      <div
        className={`bg-white ${addonBefore?'flex flex-row-reverse  ':''} ${addonWasClicked && addonAfter?`rounded-s-full  rounded-tr-full `:addonWasClicked && addonBefore?'rounded-tl-[2rem] rounded-tr-[2rem]':'rounded-full '} h-[50px] relative my-3.5 ${
          meta.touched && meta.error && !['radio', 'checkbox'].includes(type)  && Object.keys(meta.error).length? errorClassName?errorClassName:'ring-2 ring-red-500/50' : ''
        } ${className}`}
        {...rest}
      >
        <input
          className='wos-shaded-checkbox self-start relative top-[3px] cursor-pointer peer shrink-0 appearance-none w-[12px] h-[12px] border-2 border-[#6f6f6f] rounded-sm !bg-white hover:not-checked:!bg-[#1d1d3933] checked:bg-blue-800 checked:border-0 before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-primary-blue checked:!bg-primary-blue checked:before:bg-primary-blue hover:before:opacity-10'

          id={id}
          
          type={type}
          {...field}
          placeholder={placeholder}
          {...rest}
        />

        <svg
          className="absolute w-4 h-4 mt-1 hidden peer-checked:block pointer-events-none max-w-[10px] transform translate-x-[1px] translate-y-[-22px]"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>

        {/* Addon Component */}
        {addonAfter && React.isValidElement(addonAfter) && (
          <div
            className={`absolute top-0 rounded-full right-0 h-full flex items-center`}
            style={{ width: addonWidthInRem }}
          >
            {React.cloneElement(addonAfter, { noErrorHandling: true, isAddon:true, setAddonWasClicked })}
          </div>
        )}

        {addonBefore && React.isValidElement(addonBefore) && (
          <div
            className={`absolute top-1/2 transform -translate-y-[2.3rem] left-0  ${addonWasClicked?'right-0':''} bottom-[14rem]`}
           
          >
            {React.cloneElement(addonBefore, { noErrorHandling: true, isAddon:true, setAddonWasClicked })}
          </div>
        )}
      </div>

      {/* Validation Error */}
      {meta.touched && meta.error && !['radio', 'checkbox'].includes(type)  && (
        <span className={errorClassName? errorClassName: "text-xs text-red-400 block"}>{meta.error}</span>
      )}
    </>
  );
};

export default Input;
